module.exports = __webpack_public_path__ + "static/img/ban4.13f3009.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/ban4.jpg
// module id = XhU2
// module chunks = 55